import * as React from "react";
import translations from "../../../locales/en/data.json";

const TranslationsContext = React.createContext(translations);

export default TranslationsContext;
